module.exports = __webpack_public_path__ + "img/alfred.f3ac2a02.svg";